// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { NgIf } from '@angular/common';
import {
  AfterViewInit,
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  ElementRef,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { isMISystem } from '../../../shared/utils/modalityHelpers';
import { PortalWebAppConfigurationService } from '../../services/portal-web-app-configuration.service';
import { RouteService } from '../../services/routeService.service';
import { SystemOverviewService } from '../../services/systemOverview.service';
import { HelloThere } from '../hello-there/hello-there.component';
import { MIApplications } from '../mi-applications/mi-applications.component';
import { UsefulApplications } from '../useful-applications/useful-applications';

@Component({
  selector: 'app-landing-page',
  templateUrl: `./landingPage.component.html`,
  styleUrls: ['./landingPage.component.scss'],
  standalone: true,

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    HelloThere,
    NgIf,
    UsefulApplications,
    MIApplications,
    TranslateModule,
  ],
})
export class LandingPageComponent implements AfterViewInit {
  modality$ = this.systemOverviewService.modalities.lastSuccessfulData$;
  systemDetails$ = this.systemOverviewService.systemDetails.lastSuccessfulData$;

  tab = 1;

  shuiHacks(): void {
    // icon in sh-search is missing label atm.
    const searchIcon = this.componentRef?.nativeElement
      ?.querySelector('sh-search')
      ?.shadowRoot?.querySelector('sh-icon');
    searchIcon?.setAttribute('aria-label', 'Search');
  }
  ngAfterViewInit(): void {
    requestAnimationFrame(() => this.shuiHacks());
  }

  isMISystem = isMISystem;

  constructor(
    protected systemOverviewService: SystemOverviewService,
    protected routeService: RouteService,
    protected portalWebAppConfiguration: PortalWebAppConfigurationService,
    protected componentRef: ElementRef,
  ) {
    this.portalWebAppConfiguration.getUsefulAppConfiguration({});
  }
}
